import { lazy } from "react";
import Loadable from "../../../../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../../../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../../../../../constants/enums";

const BusinessTaskActivity = Loadable(
  lazy(() =>
    import("./TaskActivity").then(({ BusinessTaskActivity }) => ({
      default: BusinessTaskActivity,
    }))
  )
);
export const TaskActivityRoutes = [
   {
            path: "/business-policy/:customerId/task-activity-tab/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
                <BusinessTaskActivity />
              </AuthorizedRoute>
            ),
          },
         
];
